// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { isGuestSelector, getCurrentUser } from '../../../user/currentUserSelector';
import { isMobileSize } from '../../../utils/grid/gridSizeSelector';

// Utils
import {
    isSupportedBrowser,
    validateRequiredFeatures,
    getBrowserUnsupportedAcknowledgement,
    setBrowserUnsupportedAcknowledgement,
} from './browserDetectionService';

import {
    isSafari,
    isFirefox,
    isChrome,
    isMobile,
    isIOS,
    getPlatform,
    isIpad,
    isTouch,
} from '../../../utils/services/browser';

// Components
import BrowserWarning from './BrowserWarning';

const selector = createStructuredSelector({
    isGuest: isGuestSelector,
    currentUser: getCurrentUser,
    isMobile: () => isMobile(),
    isIOS: () => isIOS(),
    isUsingMobileView: isMobileSize,
});

const setBodyClass = (className) => {
    document.body.classList.add(className);
};

const getBrowserClassName = () => {
    if (isChrome()) return 'chrome';
    if (isSafari()) return 'safari';
    if (isFirefox()) return 'firefox';
};

@connect(selector)
class BrowserDetection extends React.Component {
    constructor() {
        super();
        this.state = {
            supportedBrowser: false,
            acknowledgement: false,
            features: {
                isValid: true,
                errors: [],
            },
        };

        this.acknowledgeUnsupportedBrowser = this.acknowledgeUnsupportedBrowser.bind(this);
    }

    componentWillMount() {
        const supportedBrowser = isSupportedBrowser();
        const requiredFeatureValidationResult = validateRequiredFeatures();

        let acknowledgement = false;
        if (!supportedBrowser || !requiredFeatureValidationResult.isSupported) {
            acknowledgement = getBrowserUnsupportedAcknowledgement();
        }

        this.setState({
            supportedBrowser,
            acknowledgement,
            features: requiredFeatureValidationResult,
        });

        const browserClassName = getBrowserClassName();

        if (browserClassName) setBodyClass(browserClassName);
        if (isTouch()) setBodyClass('touch-device');
        if (isIpad()) setBodyClass('ipad-device');

        const platform = getPlatform();
        setBodyClass(`platform-${platform}`);
    }

    acknowledgeUnsupportedBrowser() {
        // Save the decision to local storage so they don't keep on getting asked on page refresh
        setBrowserUnsupportedAcknowledgement();
        // Save the decision to state so they are presented with the workspace / login page
        this.setState({ acknowledgement: true });
    }

    render() {
        const { supportedBrowser, features, acknowledgement } = this.state;

        return (
            <BrowserWarning
                {...this.props}
                acknowledgeUnsupportedBrowser={this.acknowledgeUnsupportedBrowser}
                supportedBrowser={supportedBrowser}
                features={features}
                acknowledgement={acknowledgement}
            />
        );
    }
}

BrowserDetection.propTypes = {
    children: PropTypes.element,
};

export default BrowserDetection;
